import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const RankingActivity = ({
  currentActivity,
  submitted,
  rankingSelections,
  setRankingSelections,
  handleOptionChange,
  setHasUserInteracted,
}) => {
  const isSubmitted = submitted?.isSubmitted || false;

  const correctOrder = currentActivity.Options.map((opt) => opt.Value);
  const userOrder = rankingSelections.map((opt) => opt.Value);

  const isCorrect =
    isSubmitted && JSON.stringify(userOrder) === JSON.stringify(correctOrder);

  const handleDragEnd = (result) => {
    if (!result.destination || isSubmitted) return;

    const updated = Array.from(rankingSelections);
    const [moved] = updated.splice(result.source.index, 1);
    updated.splice(result.destination.index, 0, moved);

    setRankingSelections(updated);
    setHasUserInteracted(true);

    handleOptionChange(
      currentActivity.ContentId,
      1,
      updated.map((o) => o.Value)
    );
  };

  const resultBgColor = isSubmitted
    ? isCorrect
      ? "#e8f5e9"
      : "#ffebee"
    : "transparent";

  return (
    <>
      {/* --------- DRAG LIST --------- */}
      <Box sx={{ mt: 2 }}>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="ranking">
            {(provided) => (
              <Box
                ref={provided.innerRef}
                {...provided.droppableProps}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                {rankingSelections.map((item, index) => (
                  <Draggable
                    key={item.Id}
                    draggableId={String(item.Id)}
                    index={index}
                    isDragDisabled={isSubmitted}
                  >
                    {(provided, snapshot) => (
                      <Paper
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        sx={{
                          p: 2,
                          cursor: isSubmitted ? "not-allowed" : "grab",
                          boxShadow: snapshot.isDragging ? 6 : 2,
                        }}
                      >
                        <Typography>{item.Value}</Typography>
                      </Paper>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </Box>
            )}
          </Droppable>
        </DragDropContext>
      </Box>

      {/* --------- RESULT --------- */}
      {isSubmitted && (
        <Box
          sx={{
            mt: 2,
            p: 2,
            borderRadius: 2,
            backgroundColor: resultBgColor,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {isCorrect ? (
              <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
            ) : (
              <CancelIcon sx={{ fontSize: 40, color: "red" }} />
            )}
          </Box>

          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              mt: 1,
              color: isCorrect ? "green" : "red",
            }}
          >
            {isCorrect ? "Correct Answer!" : "Incorrect Answer!"}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default RankingActivity;
